import { render, staticRenderFns } from "./SearchCustomers.vue?vue&type=template&id=518ec68b&"
import script from "./SearchCustomers.vue?vue&type=script&lang=js&"
export * from "./SearchCustomers.vue?vue&type=script&lang=js&"
import style0 from "./SearchCustomers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports